import { Canvas } from 'fabric';
import { getMnemonicViewportSceneBounds } from './mnemonic-canvas-bounds.util';

export class MnemonicGridRenderer {
    static readonly DEFAULT_GRID_SIZE = 35;

    static draw(canvas: Canvas | undefined, gridSize = MnemonicGridRenderer.DEFAULT_GRID_SIZE): void {
        if (!canvas) {
            return;
        }

        const ctx = canvas.contextContainer;
        const viewport = getMnemonicViewportSceneBounds(canvas);
        const startX = Math.floor(viewport.left / gridSize) * gridSize;
        const startY = Math.floor(viewport.top / gridSize) * gridSize;
        const vpt = canvas.viewportTransform;

        if (!vpt) {
            return;
        }

        ctx.save();
        ctx.setTransform(vpt[0], vpt[1], vpt[2], vpt[3], vpt[4], vpt[5]);
        ctx.beginPath();
        ctx.strokeStyle = '#cecece';
        ctx.globalCompositeOperation = 'destination-over';

        for (let x = startX; x <= viewport.right; x += gridSize) {
            ctx.moveTo(x + 0.5, startY);
            ctx.lineTo(x + 0.5, viewport.bottom);
        }

        for (let y = startY; y <= viewport.bottom; y += gridSize) {
            ctx.moveTo(startX, y + 0.5);
            ctx.lineTo(viewport.right, y + 0.5);
        }

        ctx.stroke();
        ctx.restore();
    }

    static createAfterRenderHandler(getCanvas: () => Canvas | undefined, gridSize = MnemonicGridRenderer.DEFAULT_GRID_SIZE): () => void {
        return () => MnemonicGridRenderer.draw(getCanvas(), gridSize);
    }
}
